import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import GetLoanLoanSecurity from "Communication/ApiClasses/GetLoanLoanSecurityRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleGetLoanLoanSecurity(action) {
  yield put(
    doLoadingStart(STRINGS.LOAN_DETAILS.API_KEYS.LOAN_GET_LOAN_SECURITY)
  );
  const getLoanLoanSecurity = new GetLoanLoanSecurity(
    action.data.applicationId
  );
  try {
    const result = yield call(getLoanLoanSecurity.getData);
    yield put({
      type: actionTypes.LOAN_GET_LOAN_SECURITY_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_GET_LOAN_SECURITY_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.LOAN_DETAILS.API_KEYS.LOAN_GET_LOAN_SECURITY)
    );
  }
}

// watcher
function* getLoanLoanSecurityWatcherSaga() {
  yield takeLatest(
    actionTypes.LOAN_GET_LOAN_SECURITY,
    handleGetLoanLoanSecurity
  );
}

export default getLoanLoanSecurityWatcherSaga;
